import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { id: String, text: String, withIndex: Boolean };

  add(event) {
    const box = document.getElementById(this.idValue);
    const currentIndex = box.childElementCount;

    box.insertAdjacentHTML(
      'beforeend',
      event.currentTarget.dataset.fields.replace(/new_field/g, new Date().getTime())
    );

    if (this.withIndexValue) {
      const childIndex = document.getElementsByClassName('child-index');
      const lastChild = childIndex[childIndex.length - 1];

      lastChild.innerHTML = currentIndex + 1;
    }
  }

  destroy(event) {
    if (confirm(this.textValue)) {
      const dynamicFields = event.currentTarget.closest('.dynamic-fields');

      dynamicFields.remove();
    }
  }
}
